import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import * as GetOrgSecrets from "./useOrgSecrets";

export function useDeleteSecretMutation() {
  const { secretService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, { secretName: string; orgId: string }>({
    mutationFn: ({ secretName, orgId }) => {
      return secretService.deleteSecretByName(secretName, orgId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: GetOrgSecrets.getQueryKey(),
      });
    },
  });
}
